import { SWRConfiguration } from 'swr';

import { Roles } from '~/data/user';
import {
  UseSWROutput,
  optionalDateFromSWRCache,
  optionalDateToSWRCache,
  useSWR,
} from '~/hooks/useSWR';
import { AbsenceReadApiClient, People } from '~/services/Http';

import { AbsenceStatusEnum } from '../../client.people.generated';

export const GET_TEAM_ABSENCES_SWR_KEY = 'AbsenceReadApiClient.getTeamAbsences';

export function useGetTeamAbsences(
  args: {
    employeeId: string;
    lang?: string;
    offset?: number;
    limit?: number;
    startDate?: Date;
    endDate?: Date;
    order?: People.Order4;
    treeId?: string;
    statuses?: AbsenceStatusEnum[];
    roles?: string[] | Roles[];
    unitIds?: number[];
  },
  swrConfig?: SWRConfiguration<People.AbsenceDto[]>,
  disable?: boolean,
): UseSWROutput<People.AbsenceDto[]> {
  return useSWR(
    !disable
      ? [
          GET_TEAM_ABSENCES_SWR_KEY,
          args.employeeId,
          args?.lang ?? undefined,
          args?.offset ?? undefined,
          args?.limit ?? undefined,
          optionalDateToSWRCache(args?.startDate),
          optionalDateToSWRCache(args?.endDate),
          args?.order ?? undefined,
          args?.treeId ?? undefined,
          args?.statuses ?? undefined,
          args?.unitIds ?? undefined,
          args?.roles ?? undefined,
        ]
      : null,
    ([
      _,
      employeeId,
      lang,
      offset,
      limit,
      startDate,
      endDate,
      order,
      treeId,
      statuses,
      unitIds,
      roles,
    ]) =>
      AbsenceReadApiClient.getTeamAbsences(
        employeeId,
        order,
        offset,
        limit,
        optionalDateFromSWRCache(startDate),
        optionalDateFromSWRCache(endDate),
        lang,
        treeId,
        unitIds,
        roles,
        statuses,
      )
        .then((r) => r.data)
        .catch((error) => {
          console.error(error);
          return [];
        }),
    swrConfig,
  );
}
